import { AccountingTaxCode } from '../accounting-tax-code.model';
import { roundCurrency } from '../../shared/utils/commercial-money';

export interface TaxableAccountingLine {
    amountExclTax: number;
    taxAmount: number;
    taxCode: string;
}

const DEFAULT_VAT_CODE = 'VAT';
const DEFAULT_VAT_RATE = 15;

/**
 * Resolves the rate from the company's tax-code master. VAT retains the Saudi
 * 15% default while the master data is loading, so a newly-entered line cannot
 * silently remain tax-free just because the asynchronous lookup has not
 * completed yet.
 */
export function taxRateForCode(taxCode: string | undefined, taxCodes: AccountingTaxCode[]): number {
    const normalizedCode = taxCode?.trim().toUpperCase();
    const configuredCode = taxCodes.find(code => code.taxCode?.trim().toUpperCase() === normalizedCode);
    const configuredRate = Number(configuredCode?.taxRate);
    if (configuredCode?.taxRate !== undefined && configuredCode.taxRate !== null && Number.isFinite(configuredRate)) {
        return Math.max(0, configuredRate);
    }
    return normalizedCode === DEFAULT_VAT_CODE || normalizedCode === 'VAT15' ? DEFAULT_VAT_RATE : 0;
}

export function calculateTaxAmount(amountExclTax: number | undefined, taxCode: string | undefined,
        taxCodes: AccountingTaxCode[], currencyCode = 'SAR'): number {
    const netAmount = Math.max(0, Number(amountExclTax) || 0);
    const taxAmount = netAmount * taxRateForCode(taxCode, taxCodes) / 100;
    return roundCurrency(taxAmount, currencyCode);
}

export function recalculateLineTax<T extends TaxableAccountingLine>(line: T,
        taxCodes: AccountingTaxCode[], currencyCode = 'SAR'): T {
    return {
        ...line,
        taxAmount: calculateTaxAmount(line.amountExclTax, line.taxCode, taxCodes, currencyCode)
    };
}
